









import Vue from 'vue';
import { UserService } from "@/services";
import { appMixinFactory } from '@previnet/pnet-utils';
import config from "@/services/config";

const baseUrl = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/` + config.serviceContext;

const userService = new UserService(baseUrl,null);

export default Vue.extend({
  mixins: [
    appMixinFactory({
      userService
    }),
  ],
});
